/**
 * Resolve relative Supabase Storage paths to public CDN object URLs.
 * Absolute http(s) / data URIs pass through unchanged.
 * CheepSweepz frontend uses CRA — use process.env.REACT_APP_* only.
 */

const DEFAULT_HUB_URL = "https://sdnbxlttdpajjghkiwhf.supabase.co";

function resolveBaseUrl(explicit) {
  if (typeof explicit === "string" && explicit.trim()) {
    return explicit.replace(/\/$/, "");
  }
  if (typeof window !== "undefined" && window.__DHC_SUPABASE_URL) {
    return String(window.__DHC_SUPABASE_URL).replace(/\/$/, "");
  }
  const fromEnv =
    (typeof process !== "undefined" &&
      process.env &&
      (process.env.REACT_APP_SUPABASE_URL ||
        process.env.REACT_APP_DHC_SUPABASE_URL ||
        process.env.REACT_APP_DHC_HUB_SUPABASE_URL)) ||
    "";
  if (fromEnv) return String(fromEnv).replace(/\/$/, "");
  return DEFAULT_HUB_URL;
}

/**
 * @param {string|null|undefined} path
 * @param {string} fallbackPath
 * @param {string} [supabaseUrl]
 * @returns {string}
 */
export function getCDNImage(path, fallbackPath, supabaseUrl) {
  if (!path || String(path).trim() === "") {
    return normalizeMaybeRelative(fallbackPath, supabaseUrl);
  }

  const trimmed = String(path).trim();
  if (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("data:")
  ) {
    return trimmed;
  }

  return normalizeMaybeRelative(trimmed, supabaseUrl);
}

function normalizeMaybeRelative(path, supabaseUrl) {
  if (!path) return path;
  if (
    path.startsWith("http://") ||
    path.startsWith("https://") ||
    path.startsWith("data:")
  ) {
    return path;
  }
  const base = resolveBaseUrl(supabaseUrl);
  const objectPath = String(path).replace(/^\//, "");
  return `${base}/storage/v1/object/public/${objectPath}`;
}
